import { render, staticRenderFns } from "./aRoomDetailReceipt.vue?vue&type=template&id=198bf10f"
import script from "./aRoomDetailReceipt.vue?vue&type=script&lang=js"
export * from "./aRoomDetailReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports